<div class="flex flex-col flex-auto md:w-200 md:min-w-200 max-h-90vh -m-6 relative" style="min-width: 80vw; max-height: 90vh;">

    <div class="flex flex-row justify-between bg-gray-100 dark:bg-gray-700 px-4 py-2 border-b">
        <div class="font-semibold text-center flex items-center text-2xl">
            <div *ngIf="!release" class="w-6 h-6 mr-2">
                <mat-spinner [diameter]="36" [mode]="'indeterminate'"></mat-spinner>
            </div>
            <div *ngIf="release">
                {{release.title || ("untitled-release" | transloco)}}
            </div>
            <app-status-pill *ngIf="release" class="ml-2" [color]="
                release.status === 'published' ? 'success' :
                release.status === 'pending-approval' ? 'warning' :
                release.status === 'pending-release-date' ? 'warning' :
                release.status === 'rejected' ? 'error' :
                release.status === 'rejected-permanently' ? 'error' :
                release.status === 'subscription-expired' ? 'error' :
                release.status === 'taken-down' ? 'error' :
                'basic'
                " [titleKey]="
                release.status === 'published' ? 'status-published' :
                release.status === 'pending-approval' ? 'status-pending' :
                release.status === 'pending-release-date' ? 'status-pending' :
                release.status === 'rejected' ? 'status-rejected' :
                release.status === 'rejected-permanently' ? 'status-rejected' :
                release.status === 'subscription-expired' ? 'status-failed' :
                release.status === 'taken-down' ? 'status-taken-down' :
                'status-draft'
                "></app-status-pill>
        </div>

        <button (click)="matDialogRef.close()" [tabIndex]="-1" mat-icon-button>
            <mat-icon [svgIcon]="'heroicons_outline:x-mark'" class="text-current"></mat-icon>
        </button>
    </div>

    <app-release-summary *ngIf="release" [release]="release" (closeEmitter)="closeModal()"></app-release-summary>
    <div *ngIf="!release" class="w-full flex items-center justify-center py-50">
        <mat-progress-spinner [diameter]="36" [mode]="'indeterminate'">
        </mat-progress-spinner>
    </div>

    <div
        class="flex flex-auto flex-col sm:flex-row justify-end border-t bg-gray-100 dark:bg-gray-700 p-4 space-y-4 md:space-y-0">
        <div class="flex flex-row my-auto space-x-4">
            <button (click)="matDialogRef.close()" mat-stroked-button type="button">
                <span>{{'close-button' | transloco}}</span>
            </button>
        </div>
    </div>
</div>
